import { MobileAppScaffold } from './MobileAppPlaceholder';
import AppUsersTab from './AppUsersTab';

export default function EcoFrontManagePage() {
  return (
    <MobileAppScaffold
      title="Ecofront"
      renderAppUsers={() => <AppUsersTab />}
    />
  );
}
